import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {User, UserAuth} from '@core/models';
import {ROLE_ID_KEYS, RoleIds} from '@core/enums';
import {Observable, of} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '@env';
import {catchError, map} from 'rxjs/operators';
import {CookieService} from 'ngx-cookie-service';
import {ValidationHelper} from '@core/helpers';
import {RouterLinks} from '@core/constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private currentUser: User;
  isPodcastHost: boolean;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient,
  ) {
  }

  get user(): User {
    return this.currentUser;
  }

  set user(user: User) {
    this.currentUser = user;
  }

  get isLoggedIn(): Observable<boolean> {
    return this.checkToken();
  }

  get accessToken(): string {
    return this.cookieService.get('access_token') || null;
  }

  set accessToken(token: string) {
    this.cookieService.set('access_token', token, 30, '/', null, false, 'Strict');
  }

  public logout(): void {
    this.cookieService.deleteAll('/');
    this.currentUser = null;
    this.router.navigate([RouterLinks.LOGIN]);
  }

  private checkToken(): Observable<boolean> {
    if (!this.accessToken) {
      return this.unauthorized();
    }
    return this.http.get(`${environment.apiUrl}users/auth`).pipe(
      catchError(() => {
        return this.unauthorized();
      }),
      map((response: UserAuth) => {
        this.currentUser = {
          user_id: response.user_id,
          manager_id: response.manager_id,
          username: response.username,
          role_id: response.user_type_id,
          role: ROLE_ID_KEYS.get(response.user_type_id),
          created_at: response.createdate,
          image: ValidationHelper.checkStringNull(response.photo),
          is_custom: response.is_custom
        };
        this.isPodcastHost = this.currentUser.role_id === RoleIds['podcast host'];

        return true;
      })
    );
  }

  private unauthorized(): Observable<boolean> {
    this.logout();
    return of(false);
  }

  public updateUserRole(userRoleId: number): void {
    this.user.role_id = userRoleId;
    this.user.role = ROLE_ID_KEYS.get(userRoleId);
    this.user = this.user;
  }

}
